export const VYBY_PRESET_KIND_CAMERA_BODY = 'camera_body'
export const VYBY_PRESET_KIND_CAMERA_LENS = 'camera_lens'
export const VYBY_PRESET_KIND_CAMERA_FOCAL = 'camera_focal'
export const VYBY_PRESET_KIND_CAMERA_DEPTH_OF_FIELD =
  'camera_depth_of_field'
export const VYBY_PRESET_KIND_CAMERA_TRANSITION_IN = 'camera_transition_in'
export const VYBY_PRESET_KIND_CAMERA_MOTION = 'camera_motion'
export const VYBY_PRESET_KIND_CAMERA_TRANSITION_OUT = 'camera_transition_out'
